module.exports = __webpack_public_path__ + "img/cloudforest@2x.393547c.jpg";